/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.DOWNLOAD_OPTINS_REQUEST]: state => {
    state.downloadingOptins = true;
    state.downloadingOptinsFailed = false;
    state.downloadingOptinsSucceeded = false;
    state.downloadingOptinsError = false;
  },

  [types.DOWNLOAD_OPTINS_SUCCESS]: state => {
    state.downloadingOptins = false;
    state.downloadingOptinsFailed = false;
    state.downloadingOptinsSucceeded = true;
    state.downloadingOptinsError = false;
  },

  [types.DOWNLOAD_OPTINS_FAILURE]: (state, error) => {
    state.downloadingOptins = false;
    state.downloadingOptinsFailed = true;
    state.downloadingOptinsSucceeded = true;
    state.downloadingOptinsError = error;
  },

  [types.CREATE_OPTINS_REQUEST]: state => {
    state.creatingOptins = true;
    state.creatingOptinsFailed = false;
    state.creatingOptinsSucceeded = false;
    state.creatingOptinsError = null;
  },

  [types.CREATE_OPTINS_SUCCESS]: state => {
    state.creatingOptins = false;
    state.creatingOptinsFailed = false;
    state.creatingOptinsSucceeded = true;
    state.creatingOptinsError = null;
  },

  [types.CREATE_OPTINS_FAILURE]: (state, error) => {
    state.creatingOptins = false;
    state.creatingOptinsFailed = true;
    state.creatingOptinsSucceeded = false;
    state.creatingOptinsError = error;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/privacy/mutations.js